<template>
    <el-dialog :visible.sync="dialogVisible" title="学生作业管理" custom-class="custom-dialog" :close-on-click-modal="false" @opened="dialogOpen" @closed="dialogClose" width="590px">
        
        <div class="social-feed-page">
            <!-- 顶部统计信息栏 -->
            <div class="stats-header">
                <el-row :gutter="20">
                    <el-col :span="8">
                    <el-card shadow="hover" class="stat-card">
                        <div class="stat-item">
                        <i class="el-icon-document-checked"></i>
                        <span>已提交：{{ stats.submitted }}次</span>
                        </div>
                    </el-card>
                    </el-col>
                    <el-col :span="8">
                    <el-card shadow="hover" class="stat-card">
                        <div class="stat-item">
                        <i class="el-icon-chat-line-round"></i>
                        <span>已点评：{{ stats.correcCount }}次</span>
                        </div>
                    </el-card>
                    </el-col>
                    <el-col :span="8">
                    <el-card shadow="hover" class="stat-card">
                        <div class="stat-item">
                        <i class="el-icon-chat-line-square"></i>
                        <span>未点评：{{ stats.unCorrecCount }}次</span>
                        </div>
                    </el-card>
                    </el-col>
                </el-row>
            </div>
            <div class="social-feed-container">
                <div class="social-feed" 
                    v-loading="loading"
                    :element-loading-text = "loadingText"
                    element-loading-background = "rgba(255, 255,255,0.7)">

                    <el-card class="feed-item" v-for="(item, index) in feedItems" :key="index">
                         
                        <div slot="header" class="feed-header">
                            <div class="header-left">
                                <span class="user-name">{{ item.name }}</span>
                            </div>
                            <div class="header-right">
                                <span class="post-time">发布于{{ item.taskSubmitTime }}</span>
                            </div>
                        </div> 

                        <div class="feed-content">
                            {{ item.content }}
                        </div>

                        <!-- 打卡图片/视频展示 -->
                        <div class="feed-images" v-if="item.studentTaskMediaList && item.studentTaskMediaList.length > 0">
                            <span  v-for="(file, index) in item.studentTaskMediaList" :key="index">
                                <el-image :src="file.url"
                                    :preview-src-list="item.studentTaskMediaList.map(i => i.url)" fit="cover"
                                    v-if="file.fileType == 1"
                                    class="feed-image"></el-image>
                                <a v-else-if="file.fileType == 3" target="_blank" :href="file.url">查看视频</a>
                            </span>
                        </div>

                        <!-- 打卡录音展示 -->
                        <div class="feed-images" v-if="item.studentTaskAudioList && item.studentTaskAudioList.length > 0">
                            <span  v-for="(file, index) in item.studentTaskAudioList" :key="index">
                                <a v-if="file.fileType == 2" target="_blank" :href="file.url">查看视频</a>
                            </span>
                        </div>
                        
                        <!-- 点赞和留言统计 -->
                        <div class="feed-stats">
                            <span class="like-count">
                                <i class="el-icon-star-off"></i> {{ item.giveCount }} 点赞
                            </span>
                            <span class="comment-count">
                                <i class="el-icon-chat-dot-round"></i> {{ item.commentList.length }} 留言
                            </span>
                            <span class="delete-comment" @click="deleteTaskLogDialog(item.id, index)"> 删除</span>
                        </div>

                        <!-- 留言区域 -->
                        <div class="feed-comments">
                            <div class="comment"
                                v-for="(comment, cIndex) in item.commentList"
                                :key="cIndex">
                                <span class="comment-user">{{ comment.createName }}：</span>
                                <span class="comment-content">{{ comment.content }}</span>
                                <span class="comment-delete" @click="deleteComment(comment.id, index, cIndex)">
                                    删除
                                </span>
                            </div>

                            <!-- 更多留言入口 -->
                            <div class="show-more-comments" v-if="item.commentList.length > 0 
                                    && item.remainCommentCount > 0 
                                        && !item.showAllComments"
                                @click="toggleShowAll(item.id, item, index, true)">
                                查看更多留言（{{ item.remainCommentCount }}条）
                            </div>

                            <!-- 收起留言入口 -->
                            <div class="show-less-comments" v-if="item.commentList.length > 0 
                                    && item.remainCommentCount > 0 
                                            && item.showAllComments"
                                @click="toggleShowAll(item.id, item, index, false)">
                                收起留言
                            </div>
                        </div>
                    </el-card>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import http from '../../../../common/http';

export default {
    name: 'setCommentManage',
    components: {},
    props: {
        value: Boolean,
        taskList: {
            type: Object,
            default() {
                return {}
            }
        },
        clockinDate: {
            type: String,
            default() {
                return ""
            }
        }
    },
    data() {
        return {
            loading: false,
            loadingText: "",
            dialogVisible: false,
            stats: {
                submitted: 0,
                unCorrecCount: 0,
                correcCount: 0
            },
            feedItems: [],
        }
    },
    watch: {
        value(val) {
            this.dialogVisible = val
        },
        dialogVisible(val) {
            this.$emit('input', val)
        },
    },
    methods: {
        dialogOpen() {
            this.feedItems = []
            this.getData()
        },
        dialogClose() {
            this.dialogVisible = false
        },
        // 切换显示全部留言
        toggleShowAll(studentTaskId, item, index, show) {
            if(show){
                let url  = this.studentTaskCommentLogListUrl;
                let data = {
                    taskListId:studentTaskId,
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        item.commentList = res.data
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err);
                });
            }else{
                item.commentList=item.commentList.slice(0, 3)
            }
            this.$set(this.feedItems[index], 'showAllComments', show)
        },
        getData(){
            this.loading=true;
            this.loadingText="数据加载中...";

            let url  = this.clockinStudentTaskListUrl;
            let data = {
                taskListId:this.taskList.id,
                clockinDate:this.clockinDate,
            };
            this.apiPost(url,data).then((res) => {
                if(res.status == 200){
                    if(res.data.total > 0){
                        this.feedItems = res.data.list
                    }
                    // 初始状态
                    this.stats.unCorrecCount = res.data.unCorrecCount
                    this.stats.correcCount = res.data.correcCount
                    this.stats.submitted = res.data.submitted
                }else{
                    this.$commonFn.showTip(res.message,3)
                }
                this.loading=false
            },(err)=>{
                console.log(err);
                this.loading=false;
            });
        },
        // 删除留言
        deleteComment(id, postIndex, commentIndex) {
            this.$confirm('确定要删除这条留言吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {

                let url  = this.studentTaskCommentLogRemoveUrl;
                let data = {
                    id: id,
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        this.feedItems[postIndex].commentList.splice(commentIndex, 1);
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err);
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        // 删除作业任务
        deleteTaskLogDialog(id, postIndex) {
            this.$confirm('确定要删除这条作业吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let url  = this.clockinStudentTaskLogRemoveUrl
                let data = {
                    id: id,
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                        this.feedItems.splice(postIndex, 1)
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }else{
                        this.$commonFn.showTip(res.message,3)
                    }
                },(err)=>{
                    console.log(err)
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                })
            })
        }
    },
    mixins: [http]
}
</script>

<style>


.social-feed-container {
  height: 460px;
  overflow-y: auto;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.social-feed {
  padding-bottom: 20px;
}

.feed-item {
  margin-bottom: 20px;
}

.feed-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
}

.user-name {
  font-weight: bold;
  font-size: 16px;
  margin-right: 10px;
}

.post-time {
  color: #999;
  font-size: 14px;
}

.delete-post {
  color: #F56C6C;
  padding: 0;
}

.feed-content {
  padding: 10px 0;
  font-size: 15px;
  line-height: 1.5;
}

.feed-images {
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0;
}

.feed-image {
  width: 100px;
  height: 100px;
  margin-right: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
  cursor: pointer;
}

.feed-stats {
  display: flex;
  padding: 8px 0;
  border-top: 1px solid #eee;
  margin-top: 10px;
  color: #666;
  font-size: 14px;
}

.like-count, .comment-count, .delete-comment {
  margin-right: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.like-count:hover, .comment-count:hover {
  color: #409EFF;
}

.delete-comment {
  color: #F56C6C;
  margin-left: auto;
  margin-right: 0;
}

.feed-comments {
  border-top: 1px solid #eee;
  padding-top: 10px;
  margin-top: 5px;
}

.comment {
  margin-bottom: 8px;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.comment-user {
  color: #409EFF;
  font-weight: bold;
  margin-right: 5px;
}

.comment-content {
  flex: 1;
}

.comment-delete {
  color: #F56C6C;
  margin-left: 10px;
  cursor: pointer;
  visibility: hidden;
}

.comment:hover .comment-delete {
  visibility: visible;
}

.show-more-comments, .show-less-comments {
  color: #409EFF;
  font-size: 13px;
  cursor: pointer;
  margin-top: 5px;
}

.show-more-comments:hover, .show-less-comments:hover {
  text-decoration: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/page/task/components/setCommentManage.vue